var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddUser = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 23,
  fill: "none",
  viewBox: "0 0 24 23",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FF1A1A",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.392 10.478H20.49V8.575a.951.951 0 0 0-1.902 0v1.903h-1.903a.951.951 0 0 0 0 1.903h1.903v1.903a.951.951 0 0 0 1.902 0V12.38h1.903a.951.951 0 0 0 0-1.903M9.073 11.43a5.708 5.708 0 1 0 0-11.416 5.708 5.708 0 0 0 0 11.417M9.073 13.333A8.57 8.57 0 0 0 .51 21.895c0 .526.426.951.952.951h15.222a.95.95 0 0 0 .951-.95 8.57 8.57 0 0 0-8.562-8.564"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.51.014h22.834v22.834H.51z"
})))));
export { SvgAddUser as ReactComponent };
export default __webpack_public_path__ + "assets/images/addUser.svg";